module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEiSURBVHgBpZPNTcNAEIXfLEEcMR3sVkAoIR3QAeaGUCToIKKDSPyIGyklJbgDOx34TrKTsZ1ks7azdpwnWd6fmc9vvLOEDvFqOgNzDN5MyPxmoVgVBKUvugSBNNT1DB1S4d3RUwkqyRyX8CEw5+o4OuxO9XJ1+AI/cvoenUqhysXrGLiSx0ZQ6l6SZIwC1JLImaRlIEpg7UrGCTBKyMxz4nQ6F+QbLhXbBynTJrhYhVub78uMQeoPgySgXQ/SYWkQ0IGKGXlbZwF9UCGvNcj8LOS1RB8xf9SvV1ufjdFLqhHnwap+Q4R+1nQQJlONduWNFZLmDsMaJS7Ba0P66w5Mz1U/OWf1q1WHRQ6CiUDcsZvPBelv40Fv/m8R0u6/daotbgsdsXp7Ivi4VAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/MealCard/assets/star.png
// module id = 1832
// module chunks = 0